// objectivesData.js
export const objectives = [
    "To better serve the needs of the laboratory market, we aim to expand our product offerings",
    "لتلبية احتياجات سوق المختبرات بشكل أفضل، نهدف إلى توسيع عروض منتجاتنا",
    "To attract the largest number of trained cadres, especially the maintenance team, we are intensifying our recruitment and training initiatives.",
    "ولجذب أكبر عدد من الكوادر المدربة، وخاصة فريق الصيانة، فإننا نعمل على تكثيف مبادرات التوظيف والتدريب.",
    "We are committed to the continuous development of our services and methods of work.",
    "نحن ملتزمون بالتطوير المستمر لخدماتنا وطرق عملنا.",
    "We are focused on the geographical expansion of our headquarters across all cities in the Kingdom of Saudi Arabia.",
    "نحن نركز على التوسع الجغرافي لمقرنا الرئيسي في كافة مدن المملكة العربية السعودية.",
    "Let's craft a unique identity. Our work will stand out distinctly, setting us apart from others.",
    "دعونا نصنع هوية فريدة من نوعها. سوف يبرز عملنا بشكل واضح، مما يجعلنا نتميز عن الآخرين.",
    "We're dedicated to manufacturing spare parts of all shapes and types to meet diverse needs efficiently.",
    "نحن ملتزمون بتصنيع قطع الغيار من جميع الأشكال والأنواع لتلبية الاحتياجات المتنوعة بكفاءة."
    // Add more objectives as needed
  ];